var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"im-info-user__avatar"},[_c('div',{staticClass:"im-info-user__image"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image}}):_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-user"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }